import styled from 'styled-components';

export const Container = styled.div`
  .badge-novidade {
    position: absolute;
    right: 0;
    transform: translateX(-50%);
    width: auto;
    border-radius: 12px;
    padding: 0.1em 1em;
    font-size: 0.7rem;
    z-index: 1;
    top: -9px;
    color: ${(props) => props.theme.$black};
    background-color: ${(props) => props.theme.$warning};
  }

  .news-carousel {
    display: flex;
    overflow-x: auto;
    gap: 16px;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .news-carousel::-webkit-scrollbar {
    display: none;
  }

  .news-slide {
    flex: 0 0 calc(25% - 12px);
    scroll-snap-align: start;
    max-width: calc(25% - 12px);
  }

  @media (max-width: 1024px) and (min-width: 769px) {
    .news-slide {
      flex: 0 0 calc(50% - 12px);
      max-width: calc(50% - 12px);
    }
  }

  @media (max-width: 768px) {
    .news-slide {
      flex: 0 0 100%;
      max-width: 100%;
    }

    .carousel-arrow {
      display: none !important;
    }
  }

  .carousel-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.2);
    padding: 8px 8px 9px 9px;
    cursor: pointer;
    z-index: 5;
    border-radius: 5px;
    transition: background 0.3s, opacity 0.3s;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);

    &.left {
      left: -20px;
    }

    &.right {
      right: -20px;
    }

    &.disabled {
      opacity: 0.3;
      cursor: default;
      pointer-events: none;
    }
  }

  .carousel-arrow:hover {
    background: rgba(255, 255, 255, 0.9);
  }

  .carousel-arrow svg {
    font-size: 20px;
    color: #333;
  }

  .carousel-arrow.left {
    left: 0px;
  }

  .carousel-arrow.right {
    right: 0px;
  }

  .carousel-dots {
    text-align: center;

    .dot {
      display: inline-block;
      width: 10px;
      height: 10px;
      margin: 0 4px;
      background-color: #ccc;
      border-radius: 50%;
      cursor: pointer;
      transition: background 0.3s ease;
    }

    .dot.active {
      background-color: #333;
    }
  }
`;
